@if (activate()) {
<ng-content />
}
